/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderConditionalJob = new Class({
    Extends: OCS.Classes.DynamicScriptLoaderJob,
    condition: null,
    bound_methods: {},
    options: {
        'classname': "OCS.DynamicScriptLoaderConditionalJob",
        'completed_job_phase': 2,
        'condition': null,
        'onNo_complete': Function.from,
        'onYes_complete': Function.from,
        'condition_call': Function.from,
        'yes': [],
        'no': []
    },
    register_events: function () {
        this.parent();
        this.bound_methods.yes_complete = this.yes_complete.bind(this);
        this.bound_methods.no_complete = this.no_complete.bind(this);
        this.bound_methods.complete = this.complete.bind(this);
        this.bound_methods.initial_load_complete = this.process_condition.bind(this);
        this.addEvent('initial_load_complete', this.bound_methods.initial_load_complete);
    },
    register_complete_event: function () {
        this.addEvent('yes_complete', this.bound_methods.complete);
        this.addEvent('no_complete', this.bound_methods.complete);
    },
    process_condition: function () {
        var complete_callback;
        if (this.get_load_condition()) {
            complete_callback = this.bound_methods.yes_complete;
        } else {
            complete_callback = this.bound_methods.no_complete;
        }

        this.job_load(this.determine_to_be_loaded(), complete_callback);
    },
    is_script_to_be_loaded: function (script_url) {
        return this.parent(script_url) || this.options.yes.indexOf(script_url) >= 0 || this.options.no.indexOf(script_url) >= 0;
    },
    get_load_condition: function () {
        if (this.condition === null) {
            var condition = this.options.condition_call();
            if (typeof condition === 'function') {
                condition = this.options.condition;
            }
            this.condition = condition;
        }
        return this.condition;
    },
    determine_to_be_loaded: function () {
        if (this.get_load_condition()) {
            if (this.options.yes.length) {
                return this.options.yes;
            }
        } else {
            if (this.options.no.length) {
                return this.options.no;
            }
        }
    },
    // Events
    yes_complete: function () {
        this.fireEvent('yes_complete', this);
    },
    no_complete: function () {
        this.fireEvent('no_complete', this);
    }
});